webpackJsonp([35244829876280],{

/***/ 136:
/***/ (function(module, exports, __webpack_require__) {

	var baseIndexOf = __webpack_require__(74);
	
	/**
	 * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
	 * that is not found in the character symbols.
	 *
	 * @private
	 * @param {Array} strSymbols The string symbols to inspect.
	 * @param {Array} chrSymbols The character symbols to find.
	 * @returns {number} Returns the index of the last unmatched string symbol.
	 */
	function charsEndIndex(strSymbols, chrSymbols) {
	  var index = strSymbols.length;
	
	  while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
	  return index;
	}
	
	module.exports = charsEndIndex;


/***/ }),

/***/ 137:
/***/ (function(module, exports, __webpack_require__) {

	var baseIndexOf = __webpack_require__(74);
	
	/**
	 * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
	 * that is not found in the character symbols.
	 *
	 * @private
	 * @param {Array} strSymbols The string symbols to inspect.
	 * @param {Array} chrSymbols The character symbols to find.
	 * @returns {number} Returns the index of the first unmatched string symbol.
	 */
	function charsStartIndex(strSymbols, chrSymbols) {
	  var index = -1,
	      length = strSymbols.length;
	
	  while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
	  return index;
	}
	
	module.exports = charsStartIndex;


/***/ }),

/***/ 147:
/***/ (function(module, exports, __webpack_require__) {

	var baseToString = __webpack_require__(50),
	    castSlice = __webpack_require__(174),
	    charsEndIndex = __webpack_require__(136),
	    charsStartIndex = __webpack_require__(137),
	    stringToArray = __webpack_require__(178),
	    toString = __webpack_require__(19);
	
	/** Used to match leading and trailing whitespace. */
	var reTrim = /^\s+|\s+$/g;
	
	/**
	 * Removes leading and trailing whitespace or specified characters from `string`.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category String
	 * @param {string} [string=''] The string to trim.
	 * @param {string} [chars=whitespace] The characters to trim.
	 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	 * @returns {string} Returns the trimmed string.
	 * @example
	 *
	 * _.trim('  abc  ');
	 * // => 'abc'
	 *
	 * _.trim('-_-abc-_-', '_-');
	 * // => 'abc'
	 *
	 * _.map(['  foo  ', '  bar  '], _.trim);
	 * // => ['foo', 'bar']
	 */
	function trim(string, chars, guard) {
	  string = toString(string);
	  if (string && (guard || chars === undefined)) {
	    return string.replace(reTrim, '');
	  }
	  if (!string || !(chars = baseToString(chars))) {
	    return string;
	  }
	  var strSymbols = stringToArray(string),
	      chrSymbols = stringToArray(chars),
	      start = charsStartIndex(strSymbols, chrSymbols),
	      end = charsEndIndex(strSymbols, chrSymbols) + 1;
	
	  return castSlice(strSymbols, start, end).join('');
	}
	
	module.exports = trim;


/***/ }),

/***/ 537:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _trim2 = __webpack_require__(147);
	
	var _trim3 = _interopRequireDefault(_trim2);
	
	var _map2 = __webpack_require__(51);
	
	var _map3 = _interopRequireDefault(_map2);
	
	var _startsWith2 = __webpack_require__(59);
	
	var _startsWith3 = _interopRequireDefault(_startsWith2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _glamor = __webpack_require__(5);
	
	var _moment = __webpack_require__(86);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _gatsbyLink = __webpack_require__(31);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _semanticWebflow = __webpack_require__(23);
	
	var _typography = __webpack_require__(13);
	
	var _markdownToReact = __webpack_require__(90);
	
	var _seo = __webpack_require__(33);
	
	var _seoHelper = __webpack_require__(37);
	
	var _seoHelper2 = _interopRequireDefault(_seoHelper);
	
	var _package = __webpack_require__(70);
	
	var _package2 = _interopRequireDefault(_package);
	
	var _markdownStyles = __webpack_require__(122);
	
	var _markdownStyles2 = _interopRequireDefault(_markdownStyles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // ----------------------------------------------------------------------------
	// -------------------------------------------------------------------- Imports
	// ----------------------------------------------------------------------------
	// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ Libraries
	
	
	// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ Components
	
	
	// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ Locals
	
	
	// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ Abstractions
	var Fragment = _react2.default.Fragment;
	var data = _package2.default.data;
	var H1 = _typography.Elements.H1,
	    Paragraph = _typography.Elements.Paragraph;
	
	// ----------------------------------------------------------------------------
	// --------------------------------------------------------------------- Styles
	// ----------------------------------------------------------------------------
	
	var pageStyle = (0, _glamor.css)({
	  "@media(max-width: 768px)": {
	    flexDirection: "column",
	
	    "& .doc-tree": {
	      order: 2,
	      margin: "0em 1em"
	    },
	
	    "& .doc-content": {
	      order: 1,
	      borderBottom: "1px solid #d1b7a1",
	      margin: "2em 1em 1em 1em"
	    },
	
	    paddingTop: 0
	  },
	
	  paddingTop: 72,
	  backgroundImage: "linear-gradient(135deg, #fdfcfb 0%, #e2d1c3 100%)",
	  display: "flex",
	  minHeight: "100vh",
	
	  "@media(min-width: 768px)": {
	    paddingTop: "10vh",
	    paddingBottom: "10vh"
	  },
	
	  "& .md-cat": {
	    color: "rgba(0,0,12,0.625)",
	    marginBottom: 10
	  },
	
	  "& li.md-page-active": {
	    height: "auto",
	    transition: "all 100ms cubic-bezier(0.215, 0.61, 0.355, 1)",
	
	    "& span.active-dot": {
	      display: "none"
	    },
	
	    "& > a": {
	      color: "#F15D58",
	      borderBottom: "1.625px solid transparent"
	    }
	  },
	  "& .doc-tree": {
	    "& span": {
	      fontSize: "90%"
	    }
	  },
	
	  "& .md-pages": {
	    marginTop: "0px !important",
	
	    "& a": {
	      color: "rgba(0,0,12,0.625)"
	    },
	
	    "& li": {
	      marginBottom: 5,
	
	      "&:before": {
	        borderTop: "1.375px solid #858A97",
	        borderLeft: "1.375px solid #858A97"
	      },
	
	      "&:after": {
	        borderLeft: "1.375px solid #858A97",
	        bottom: "0.62em"
	      },
	
	      "&:first-child": {
	        marginTop: "15px !important"
	      },
	
	      "&:last-child": {
	        "&:before": {
	          borderLeft: "0px !important"
	        }
	      }
	    }
	  },
	
	  "& .md-headings": {
	    "& li": {
	      "&:before": {
	        borderTop: "1.375px solid #858A97",
	        borderLeft: "1.375px solid #858A97"
	      },
	
	      "&:after": {
	        borderLeft: "1.375px solid #858A97",
	        bottom: "0.62em"
	      }
	    }
	  }
	});
	var pageStyleClass = pageStyle.toString();
	
	// ----------------------------------------------------------------------------
	// ------------------------------------------------------------------ Component
	// ----------------------------------------------------------------------------
	/** DocTemplate */
	
	var DocTemplate = function (_React$Component) {
	  _inherits(DocTemplate, _React$Component);
	
	  /** standard constructor */
	  function DocTemplate(props) {
	    _classCallCheck(this, DocTemplate);
	
	    return _possibleConstructorReturn(this, _React$Component.call(this, props));
	  }
	
	  /** standard renderer */
	
	
	  DocTemplate.prototype.render = function render() {
	    // Abstract stuff
	    var pathContext = this.props.pathContext;
	    var frontmatter = pathContext.frontmatter;
	    var toc = pathContext.toc;
	    var markdownAst = pathContext.markdownAst;
	    var route = pathContext.route;
	
	    var checkedRoute = (0, _startsWith3.default)(route, "/") ? route : "/" + route;
	    var nakedRoute = checkedRoute.substr(1);
	    var headings = pathContext.headings;
	
	    var onlyDocs = [];
	    (0, _map3.default)(toc, function (_ref) {
	      var node = _ref.node;
	
	      if ((0, _startsWith3.default)((0, _trim3.default)(node.fields.route), "docs") === true) {
	        onlyDocs.push({ node: node });
	      }
	    });
	
	    // Date stuff
	    var mDate = (0, _moment2.default)(frontmatter.date);
	    var humanDate = mDate.format("dddd, MMMM Do YYYY");
	    var elapsed = mDate.fromNow();
	
	    var pageData = {
	      pageTitle: frontmatter.title,
	      nakedPageSlug: nakedRoute,
	      pageAbstract: frontmatter.abstract
	    };
	
	    var seoData = (0, _seoHelper2.default)(pageData);
	
	    var pageTitle = seoData.pageTitle,
	        generalMetaData = seoData.generalMetaData,
	        twitterSummaryCardData = seoData.twitterSummaryCardData,
	        openGraphSummaryData = seoData.openGraphSummaryData,
	        webpageSchemaData = seoData.webpageSchemaData,
	        breadcrumbSchemaData = seoData.breadcrumbSchemaData;
	
	
	    return _react2.default.createElement(
	      Fragment,
	      null,
	      _react2.default.createElement(_seo.UpdateTitle, { title: pageTitle }),
	      _react2.default.createElement(_seo.GeneralMeta, { data: generalMetaData }),
	      _react2.default.createElement(_seo.TwitterSummaryCard, { data: twitterSummaryCardData }),
	      _react2.default.createElement(_seo.OpenGraphSummary, { data: openGraphSummaryData }),
	      _react2.default.createElement(_seo.WebpageSchema, { data: webpageSchemaData }),
	      _react2.default.createElement(_seo.BreadcrumbSchema, { data: breadcrumbSchemaData }),
	      _react2.default.createElement(
	        _semanticWebflow.Page,
	        { className: _markdownStyles2.default + " " + pageStyleClass },
	        _react2.default.createElement("span", { className: "is-hidden-mobile", style: { flexGrow: 9 } }),
	        _react2.default.createElement(
	          "div",
	          {
	            className: "doc-tree",
	            style: {
	              flexGrow: 20,
	              flexBasis: 0
	            }
	          },
	          (0, _markdownToReact.tocParser)(onlyDocs, this.props.location.pathname, { localLink: _gatsbyLink2.default }, {}, { where: frontmatter.title, what: headings })
	        ),
	        _react2.default.createElement("span", { className: "is-hidden-mobile", style: { flexGrow: 2 } }),
	        _react2.default.createElement(
	          "div",
	          {
	            className: "doc-content",
	            style: {
	              flexGrow: 40,
	              flexBasis: 0
	            }
	          },
	          _react2.default.createElement(
	            _semanticWebflow.Article,
	            null,
	            _react2.default.createElement(
	              _semanticWebflow.Header,
	              { className: "stash" },
	              _react2.default.createElement(
	                H1,
	                null,
	                frontmatter.title
	              ),
	              _react2.default.createElement(
	                Paragraph,
	                null,
	                humanDate
	              ),
	              _react2.default.createElement(
	                Paragraph,
	                { className: "stash" },
	                frontmatter.abstract
	              )
	            ),
	            (0, _markdownToReact.treeCodeParser)(markdownAst, {
	              localLink: _gatsbyLink2.default,
	              linkHeaders: true,
	              trackHeaders: false,
	              nestHeaders: true
	            }, {}),
	            _react2.default.createElement(
	              _semanticWebflow.Footer,
	              { className: "stash" },
	              _react2.default.createElement(
	                Paragraph,
	                null,
	                "Copyright\xA0",
	                data.websiteCreator,
	                "\xA02018.",
	                _react2.default.createElement("br", null),
	                _react2.default.createElement("br", null),
	                "Published on ",
	                humanDate,
	                " (",
	                elapsed,
	                ")."
	              )
	            )
	          )
	        ),
	        _react2.default.createElement("span", { className: "is-hidden-mobile", style: { flexGrow: 9 } })
	      )
	    );
	  };
	
	  return DocTemplate;
	}(_react2.default.Component);
	
	DocTemplate.propTypes = {
	  pathContext: _propTypes2.default.object // eslint-disable-line react/forbid-prop-types
	};
	
	// ----------------------------------------------------------------------------
	// --------------------------------------------------------------------- Export
	// ----------------------------------------------------------------------------
	exports.default = DocTemplate;
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-doc-jsx-fcf8da2682937dbfcdcc.js